module.exports = __webpack_public_path__ + "static/media/city_college.7984deac.png";